import { getAccountKeyForMailboxInfo, type MailboxInfo } from 'owa-client-types';
import type { BizChatCompositeKey } from 'owa-bizchat-types';
import { getBizChatWindowKey } from 'owa-copilot-chat-drawer-store';

/**
 * Returns a combined key for the message state map based on mailboxInfo and targetWindow.
 * This key uniquely identifies an <account, window> pair.
 */
export function getMessageStateKey(
    mailboxInfo: MailboxInfo,
    targetWindow: Window,
    isImmersiveBizchat?: boolean
): BizChatCompositeKey {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const windowKey = getBizChatWindowKey(targetWindow, isImmersiveBizchat);
    return `${accountKey}_${windowKey}`;
}
